var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUparrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 16,
    viewBox: "0 0 29 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5966 0.377874L0.344639 13.9555C0.123412 14.182 0 14.483 0 14.796C0 15.109 0.123412 15.41 0.344639 15.6366L0.359613 15.6512C0.466859 15.7614 0.59595 15.8491 0.739034 15.9091C0.882117 15.9691 1.0362 16 1.19191 16C1.34763 16 1.50171 15.9691 1.64479 15.9091C1.78788 15.8491 1.91697 15.7614 2.02421 15.6512L14.5025 2.86536L26.9758 15.6512C27.083 15.7614 27.2121 15.8491 27.3552 15.9091C27.4983 15.9691 27.6524 16 27.8081 16C27.9638 16 28.1179 15.9691 28.261 15.9091C28.404 15.8491 28.5331 15.7614 28.6404 15.6512L28.6554 15.6366C28.8766 15.41 29 15.109 29 14.796C29 14.483 28.8766 14.182 28.6554 13.9555L15.4034 0.377874C15.2869 0.258465 15.1467 0.163401 14.9914 0.0984472C14.8361 0.033493 14.6689 0 14.5 0C14.3311 0 14.1639 0.033493 14.0086 0.0984472C13.8533 0.163401 13.7131 0.258465 13.5966 0.377874Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUparrow);
export default __webpack_public_path__ + "static/media/up arrow.b6663d62b9cc6719e75572d84fa5f112.svg";
export { ForwardRef as ReactComponent };